import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { diffMinutes, formatDurationShort } from "@/lib/work-hours";

export function DurationChip({
  startTime, endTime, className,
}: { startTime?: string | null; endTime?: string | null; className?: string }) {
  if (!startTime || !endTime) return null;
  const mins = diffMinutes(startTime, endTime);
  if (mins <= 0) return null;
  return (
    <div className={cn(
      "inline-flex items-center gap-1.5 rounded-md bg-muted px-2.5 py-1 text-[11px] font-medium text-muted-foreground",
      className,
    )}>
      <Clock className="h-3 w-3" />
      Duration: {formatDurationShort(mins)}
    </div>
  );
}
